import type { SaveCreativeCreditInput } from 'sr-types/lib/person/v1/graphql';
import type { CreativeCredit } from 'sr-types/lib/shortlist/v1/graphql';
import { toCreativeCreditInput } from '../../../shortlists/shortlist';
import type { SaveCreditsToCandidateProfileArgs } from '../types';

export const toProfileCreativeCreditInputs = (creditsToMerge: CreativeCredit[]): SaveCreativeCreditInput[] =>
    creditsToMerge.map((credit) => ({
        new: toCreativeCreditInput(credit),
        existing: null,
        forceUserChange: true
    }));

export const saveCreditsToCandidateProfile = async ({
    personId,
    isProfileEligible,
    profileUpdateMode,
    creditsToMerge,
    saveCreativeCredits
}: SaveCreditsToCandidateProfileArgs): Promise<boolean> => {
    if (!isProfileEligible || profileUpdateMode === 'none' || !personId || !creditsToMerge.length) {
        return false;
    }

    await saveCreativeCredits({
        id: personId,
        inputs: toProfileCreativeCreditInputs(creditsToMerge)
    });

    return true;
};
